import React from 'react';

const columns = ({ sorted, filtered, fromChild }) => {
  const onClickImage = (image) =>{
    console.log(image)
    fromChild(image)
}
    return [
      {
        title: "",
        dataIndex: "action",
        key: "action",
      },
      {
        title: "Name",
        dataIndex: "name",
        key: "name",
        sorter: (a, b) => a.name - b.name,
        sortOrder: sorted.columnKey === "name" && sorted.order,
      },
      {
        title: "Url",
        dataIndex: "image",
        key: "image",
        sorter: (a, b) => a.image - b.image,
        sortOrder: sorted.columnKey === "image" && sorted.order,
        
      },
      {
        title: "Last Updated On",
        dataIndex: "date",
        key: "date",
        sorter: (a, b) => a.date.length - b.date.length,
        sortOrder: sorted.columnKey === "date" && sorted.order,
      },
      {
        title: "Image",
        dataIndex: "image",
        key: "image",
        sorter: (a, b) => a.image - b.image,
        sortOrder: sorted.columnKey === "image" && sorted.order,
        render: (text, record) => (
          <img src={record.image} alt={record.name} style={{ maxWidth: '200px', maxHeight: '200px', cursor:'pointer' }} onClick={()=>onClickImage(record.image)} />
        ),
      },
    ];
  };
export default columns; 